<template lang="pug">
  v-form(
    class="form-current-email-otp-confirm"
    @submit.prevent.stop="submit"
  )
    ValidationObserver(
      ref="otpForm"
      slim
    )
      ValidationProvider(
        :name="$t('Approval code')"
        vid="code"
        rules="numeric|min:5"
        mode="lazy"
        v-slot="{ errors }"
      )
        m-otp-input(
          v-model="code"
          :error-message="errors[0]"
          :disabled="loading || initialLoading"
          @enter="submit"
        )
    p(
      v-if="newCodeSeconds"
      class="text-center text-14px medium mt-5"
    ) {{ $t('Ask code again') }} {{ formattedNewCodeTimer }} c
    e-link(
      v-if="!newCodeSeconds"
      class="w-100 mt-5"
      @click="getCodeAgain"
    ) {{ $t('Send code again') }}
    div(
      v-if="!xsDevice"
      class="two-buttons-wrapper pt-8"
    )
      v-btn(
        height="48"
        @click="closeModal(false)"
      ) {{ $t('Cancel') }}
      v-btn(
        type="submit"
        class="main-button"
        :loading="loading || initialLoading"
        :disabled="initialLoading"
      ) {{ $t('Continue') }}
</template>

<script>
import moment from 'moment/moment'
import MOtpInput from '~/modules/auth/components/modules/m-otp-input'
import ELink from '~/components/elements/links/e-link'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'FormCurrentEmailOtpConfirm',
  components: { ELink, MOtpInput },
  mixins: [responsive],
  props: {
    taskId: {
      type: String,
      default: null
    },
    closeModal: {
      type: Function,
      default: null
    },
    initialLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      code: null,
      newCodeSeconds: 60,
      timerId: null
    }
  },
  computed: {
    formattedNewCodeTimer() {
      const duration = moment.duration(this.newCodeSeconds, 'seconds')
      return moment.utc(duration.asMilliseconds()).format('mm:ss')
    }
  },
  created() {
    this.initTimer()
  },
  methods: {
    initTimer() {
      this.newCodeSeconds = 60
      this.decrementTimer()
    },
    decrementTimer() {
      this.timerId = setInterval(() => {
        this.newCodeSeconds--
        if (this.newCodeSeconds === 0) {
          clearInterval(this.timerId)
          this.timerId = null
        }
      }, 1000)
    },
    async submit() {
      const valid = await this.$refs.otpForm.validate()
      if (!valid) {
        return
      }
      try {
        this.loading = true
        await this.$store.dispatch('users/checkCurrentEmailCode', {
          id: this.taskId,
          code: this.code
        })
        this.$emit('nextStep')
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    },
    getCodeAgain() {
      this.$emit('getCodeAgain')
      this.initTimer()
    }
  }
}
</script>

<style scoped lang="scss">
@supports (-webkit-touch-callout: none) {
  .form-current-email-otp-confirm {
    input,
    textarea,
    select,
    .v-input input,
    .v-text-field input,
    .v-select input,
    .v-textarea textarea {
      font-size: 16px !important;
    }
  }
}
.form-current-email-otp-confirm {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media (min-width: map-get($breakpoints, 'sm')) {
    height: auto;
    display: inline-block;
  }
}
</style>
